import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import NavbarBottom from './NavbarBottom';
import no_image_available from '../images/no_image_available.jpg';
import ReCAPTCHA from 'react-google-recaptcha';


const GuestBook = () => {

    const [galeryList, SetGaleryList] = useState([]);

    const urlImg = `${process.env.REACT_APP_BASEURL}/galeri/`;

    const [captchaValue, setCaptchaValue] = useState(null);

    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
    };

    const recaptchaRef = useRef(null);
    const [formData, setFormData] = useState({ personal_name: '', email: '', address: '', phone: '', description: '' });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const captchaToken = recaptchaRef.current.getValue(); // Get the reCAPTCHA token

        if (!captchaToken) {
            // Send form data and captchaValue to your server for verification
            console.log('Form submitted with reCAPTCHA:', captchaValue);
            recaptchaRef.current.reset(); // Reset reCAPTCHA after submission
        } else {
            alert('Please complete the reCAPTCHA.');
        }
    };

    useEffect(() => {
        
    }, []);

    return (
        <>
            <NavbarBottom />
            <div class="max-w-full px-0 py-0 sm:px-6 lg:px-0 lg:py-0 mx-auto bg-sky-50">
                <section class="text-gray-600 body-font pb-20">
                    <div class="container px-5 py-5 mx-auto">
                        {/*<div class="flex flex-col text-center w-full mb-20">
                            <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">Buku Tamu</h1>
                            <p class="lg:w-2/3 mx-auto leading-relaxed text-base">JDIH Kota Magelang.</p>
                        </div>*/}<br />
                        <div class="flex flex-wrap -m-4">
                            <div class="w-full h-[600px] bg-white rounded-[20px] shadow p-4 flex overflow-hidden">
                                <div class="w-[35%] bg-[#FF3C3C] rounded-[20px] p-8 flex flex-col justify-between text-white relative">
                                    <div>
                                        <h2 class="text-2xl font-semibold mb-4">Bagian Hukum Setda Kota Magelang</h2>
                                        <p class="text-sm leading-relaxed mb-8">
                                            Jl. Jend. Sarwo Edhie Wibowo No.2 Kota Magelang. <br />info@baghukum.com
                                        </p>
                                        {/*<div class="flex items-start mb-4 space-x-3">
                                            <i class="fas fa-phone-alt text-white mt-1"></i>
                                            <div class="flex flex-col text-white text-sm space-y-1">
                                                <span>info@baghukum.com</span>
                                            </div>
                                        </div>
                                        <div class="flex items-center mb-4 space-x-3">
                                            <i class="fas fa-envelope text-white"></i>
                                            <span class="text-sm">info@baghukum.com</span>
                                        </div>*/}
                                       
                                    </div>
                                    <div class="absolute right-[-60px] bottom-[-60px] w-[200px] h-[200px] bg-white opacity-10 rounded-full"></div>
                                </div>

                                <div class="w-[65%] p-10">
                                    <form onSubmit={handleSubmit}>
                                        <div class="grid grid-cols-2 gap-6 mb-8">
                                            <div>
                                                <label class="text-sm text-gray-500 block mb-1">Nama</label>
                                                <input type="text" name="personal_name" value={formData.personal_name} onChange={handleChange} class="w-full border-b border-gray-300 pb-1 font-semibold text-[#2d2d2d]" required />
                                            </div>
                                            <div>
                                                <label class="text-sm text-gray-500 block mb-1">Email</label>
                                                <input type="email" name="email" value={formData.email} onChange={handleChange} class="w-full border-b border-gray-300 pb-1 font-semibold text-[#2d2d2d]" required />
                                            </div>
                                        </div>
                                        <div class="grid grid-cols-2 gap-6 mb-8">
                                            <div>
                                                <label class="text-sm text-gray-500 block mb-1">Alamat</label>
                                                <input type="text" name="address" value={formData.address} onChange={handleChange} class="w-full border-b border-gray-300 pb-1 font-semibold text-[#2d2d2d]" required />
                                            </div>
                                            <div>
                                                <label class="text-sm text-gray-500 block mb-1">No Telepon/HP</label>
                                                <input type="text" name="phone" value={formData.phone} onChange={handleChange} class="w-full border-b border-gray-300 pb-1 font-semibold text-[#2d2d2d]" required />
                                            </div>
                                        </div>
                                        <div class="mb-8">
                                            <label class="text-sm text-[#00c8c8] block mb-2">Pesan</label>
                                            <div class="flex items-center justify-between pb-2">
                                                <textarea rows="4" name="description" value={formData.description} onChange={handleChange} class="w-full bg-[#F1F6FB] border border-[#D1D5DB] rounded-md p-3 text-sm text-[#9CA3AF]"></textarea>
                                            </div>
                                        </div>
                                       
                                        <ReCAPTCHA
                                            sitekey='6LdVc3srAAAAABbKY6qqLMgenQZFHqqAwbZM7zc7'
                                            ref={recaptchaRef}
                                        />

                                        <button class="mt-4 bg-[#00c8c8] text-white px-6 py-2 rounded-md font-medium text-sm hover:bg-[#00b4b4] transition" type="submit">Submit</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default GuestBook;
